module.exports = __webpack_public_path__ + "static/img/logo.4c33c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 27